/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useGetTradesInvalidator } from './use-get-trades';

/**
 * `Payload` type.
 */

type Payload = {
  transactionId: number;
  amount: string;
  total: string;
  unitPrice: string;
};

/**
 * Edit transaction.
 */

async function editTransaction(
  client: AxiosInstance,
  transactionId: number,
  amount: string,
  total: string,
  unitPrice: string
): Promise<void> {
  await client({
    method: 'patch',
    data: {
      amount,
      total,
      unitPrice
    },
    url: resolveAppUrl('appsCryptoDeleteTransaction', { interpolations: { id: transactionId } })
  });
}

/**
 * Export `usePostEditTransaction`.
 */

export function usePostEditTransaction() {
  const client = useRequestProvider();
  const invalidator = useGetTradesInvalidator();

  return useMutation({
    mutationFn: async ({ transactionId, amount, total, unitPrice }: Payload) => {
      const result = await editTransaction(client, transactionId, amount, total, unitPrice);

      await invalidator();

      return result;
    },
    onSuccess: () => {
      // Nothing...
    }
  });
}
